import { toRFC3339UTC } from './geohashUtil';

export const SEED_LIKES = [
  { thread_id: 1, user_id: 1002, created_at: toRFC3339UTC(new Date()) },
  { thread_id: 1, user_id: 1003, created_at: toRFC3339UTC(new Date()) },
  { thread_id: 2, user_id: 1001, created_at: toRFC3339UTC(new Date()) },
  { thread_id: 5, user_id: 1001, created_at: toRFC3339UTC(new Date()) },
  { thread_id: 5, user_id: 1004, created_at: toRFC3339UTC(new Date()) },
];
